module.exports = __webpack_public_path__ + "static/media/wanyin-title.f583ed9a.svg";